module.exports = __webpack_public_path__ + "static/media/milk_short_header.cfe9d4b9.png";